/* eslint-disable eag/match-named-export */
import {createContext} from 'shared/web';

export type TranslationInterpreter = (key: string, ...args: unknown[]) => string;

export const [TranslationContextProvider, useTranslationContext] =
  createContext<TranslationInterpreter>({
    strict: true,
    name: 'TranslationContext',
  });
